import { CButton, CSpinner } from "@coreui/react";
import React from "react";

const AppButton = ({ name, className, variant, onClick, loading, size , disabled}) => {
  return (
    <CButton
      color="primary"
      variant={variant || "outline"}
      className={className}
      onClick={onClick}
      size={size || 'md'}
      disabled={disabled}
      style={{
        cursor : disabled ? 'not-allowed' : 'pointer'
      }}
    >
      {loading ? (
        <>
          <CSpinner size="sm" className="me-2" />
        </>
      ) : (
        name
      )}
    </CButton>
  );
};

export default AppButton;
